export enum CampaignStageType {
    Input,
    ImportAndRefine,
    ValidateAndApprove,
    Publish
}